window._ = require('lodash')

import Choices from "choices.js"
window.Choices = Choices

import flatpickr from "flatpickr"
window.flatpickr = flatpickr

import Alpine from 'alpinejs'
import ajax from '@imacrayon/alpine-ajax'
window.Alpine = Alpine
Alpine.plugin(ajax)

Alpine.magic('validateDuration', () => (start_time, end_time, duration) => {
    let s = new Date("1970-01-01T" + start_time);
    let e = new Date("1970-01-01T" + end_time);
    if (s >= e) {
        e.setDate(e.getDate() + 1)
    }
    let hrs = ((e.getTime() - s.getTime()) / 1000) / (60 * 60);
    return hrs > duration;
})

Alpine.start()
